import { type MouseEvent, type ReactNode } from "react";

export interface PropCTL_Button{
  children:ReactNode;
  className?:string;
  onClick?: (e:MouseEvent)=>void;
}
export default function CTL_Button(prop:PropCTL_Button){
  return <>
    <div className={
      `w-fit
      border border-zinc-200 rounded-md
      px-3 py-1 cursor-pointer
      flex justify-center items-center
      ${prop.className}
    `} onClick={(e)=>prop.onClick&&prop.onClick(e)}
    >
      { prop.children }
    </div>
  </>
}

